export function minTwoDigits(n) {
  n = n.toString();
  return n?.split(".")[1]?.length < 2 ? n + "0" : n;
}
